import { ModelEvent } from 'src/broadcast/Events';

class UserGuidingUserPayloadPublished extends ModelEvent<void> {
  public namespace = '.App\\Events\\UserGuidingUserPayloadPublished';
}

export default UserGuidingUserPayloadPublished;
